/* eslint-disable react/require-default-props */
import React, { useState, useEffect } from 'react';
import classNames from 'classnames';
import './TextFilterStyles.scss';
/**
 * TextFilter
 * Inline debounced free-text filter. No popup and no chevron — the input lives
 * in the same chip as the other FilterBar filters.
 *   - Idle (empty, blurred): gray chip, label only
 *   - Focused: purple chip, text input enabled
 *   - Valued (blurred with text): purple chip, label + value
 * @version 1.1.0
 * @since 2026-05-04
 */
export function TextFilter({ field, label, value, onChange, debounceMs = 300, placeholder = '', disabled = false }) {
    const [localValue, setLocalValue] = useState(value);
    const [focused, setFocused] = useState(false);
    const inputId = `text-filter-${field}`;
    const hasValue = localValue !== '';
    useEffect(() => {
        setLocalValue(value);
    }, [value]);
    useEffect(() => {
        if (localValue === value)
            return undefined;
        const timer = setTimeout(() => {
            onChange(localValue);
        }, debounceMs);
        return () => clearTimeout(timer);
    }, [localValue, debounceMs, onChange, value]);
    const chipClass = classNames('qmb-ui-text-filter', {
        'qmb-ui-text-filter--focused': focused,
        'qmb-ui-text-filter--active': !focused && hasValue,
        'qmb-ui-text-filter--disabled': disabled
    });
    return (React.createElement("label", { className: chipClass, htmlFor: inputId },
        React.createElement("span", { className: "qmb-ui-text-filter__label" }, label),
        React.createElement("input", { id: inputId, className: "qmb-ui-text-filter__input", value: localValue, placeholder: focused ? placeholder : '', disabled: disabled, onChange: (event) => setLocalValue(event.target.value), onFocus: () => setFocused(true), onBlur: () => setFocused(false) })));
}
